export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const SAVE_RESERVATIONS = 'SAVE_RESERVATIONS';
export const REMOVE_RESERVATION = 'REMOVE_RESERVATION';
export const SAVE_RESERVATION_DONE = 'SAVE_RESERVATION_DONE';
export const SET_RESERVATION_ID = 'SET_RESERVATION_ID';

export const FETCH_CARS_FINISHED = 'FETCHED_CARS';

export const MAIN_PAGE = 'MAIN_PAGE';
export const SUCCESS_PAGE = 'SUCCESS_PAGE';
export const ADD_CAR_SUCCESSED = 'ADD_CAR_SUCCESSED';
export const SET_CAR_ACTIVE_FLAG_DONE = 'SET_CAR_ACTIVE_FLAG_DONE';
export const UPDATE_CAR_USER_PRIMARY_DONE = 'UPDATE_CAR_USER_PRIMARY_DONE';
export const MODAL_SHOWN = 'MODAL_SHOWN';
export const MODAL_HIDDEN = 'MODAL_HIDDEN';

export const GET_SPOTS_DONE = 'GET_SPOTS_DONE';
export const GET_SPOTS_LOT_DONE = 'GET_SPOTS_LOT_DONE';
export const ADD_SPOT_DONE = 'ADD_SPOT_DONE';
export const EDIT_SPOT_DONE = 'EDIT_SPOT_DONE';
export const DELETE_SPOT_DONE = 'DELETE_SPOT_DONE';

export const GET_LOTS_DONE = 'GET_LOTS_DONE';
export const ADD_LOT_DONE = 'ADD_LOT_DONE';
export const EDIT_LOT_DONE = 'EDIT_LOT_DONE';
export const GET_LOT_DONE = 'GET_LOT_DONE';
export const DELETE_LOT_DONE = 'DELETE_LOT_DONE';

export const SHARE_PLACE_DONE = 'SHARE_PLACE_DONE';
export const GET_USER_PLACES_DONE = 'GET_USER_PLACES_DONE';

export const SAVE_INPUT_VALUE = 'SAVE_INPUT_VLAUE';
export const SAVE_GENERAL_SETTINGS = 'SAVE_GENERAL_SETTINGS';
export const GET_ALL_USERS_DONE = 'GET_ALL_USERS_DONE';
export const SAVE_RECAPTCHA_TOKEN = 'SAVE_RECAPTCHA_TOKEN';
